import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Improved, accessible language toggle with a cohesive UI design
function LanguageSwitcher({ className = '' }) {
  const { lang, setLanguage } = useLanguage();

  const toggle = () => setLanguage(lang === 'en' ? 'ar' : 'en');
  const nextIsArabic = lang === 'en';
  const label = nextIsArabic ? 'العربية' : 'EN';
  const aria = nextIsArabic ? 'Switch to Arabic' : 'التبديل إلى الإنجليزية';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={aria}
      title={label}
      className={`group relative flex items-center justify-center w-10 h-10 rounded-xl bg-white/5 border border-white/10 text-white/70 transition-all duration-300 hover:bg-white/10 hover:border-white/20 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/40 active:scale-95 ${className}`}
    >
      <div className="relative overflow-hidden w-5 h-5">
        {/* EN Icon */}
        <span className={`absolute inset-0 flex items-center justify-center text-[10px] font-bold tracking-tighter transition-all duration-300 ${lang === 'en' ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
          EN
        </span>
        {/* AR Icon */}
        <span className={`absolute inset-0 flex items-center justify-center text-[10px] font-bold transition-all duration-300 ${lang === 'ar' ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
          ع
        </span>
      </div>
      
      {/* Decorative pulse effect on hover */}
      <div className="absolute inset-0 rounded-xl bg-primary-500/0 group-hover:bg-primary-500/5 transition-colors duration-300"></div>
    </button>
  );
}

export default LanguageSwitcher;
